import { render, staticRenderFns } from "./TwitterShareButton.vue?vue&type=template&id=eed4a66c"
import script from "./TwitterShareButton.vue?vue&type=script&lang=ts"
export * from "./TwitterShareButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports